import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=789ae46f&scoped=true&"
import script from "./ArticlesList.vue?vue&type=script&lang=ts&"
export * from "./ArticlesList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=789ae46f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ae46f",
  null
  
)

export default component.exports